export const calculateTaxAmounts = (subtotal, discountPercentage, gstPercentage, vatPercentage, specialLessValue = 0, specialLessType = 'fixed') => {
    const discountAmount = (subtotal * (Number(discountPercentage) || 0)) / 100;
    const subtotalAfterDiscount = subtotal - discountAmount;

    // Calculate Special Discount
    let specialDiscountAmount = 0;
    const specialVal = Number(specialLessValue) || 0;
    if (specialVal > 0) {
        if (specialLessType === 'percentage') {
            specialDiscountAmount = (subtotalAfterDiscount * specialVal) / 100;
        } else {
            specialDiscountAmount = specialVal;
        }
    }
    const subtotalAfterSpecialDiscount = subtotalAfterDiscount - specialDiscountAmount;

    // Calculate GST and VAT separately on the discounted subtotal (after special less)
    const gstAmount = (subtotalAfterSpecialDiscount * (Number(gstPercentage) || 0)) / 100;
    const vatAmount = (subtotalAfterSpecialDiscount * (Number(vatPercentage) || 0)) / 100;

    return {
        discountAmount,
        specialDiscountAmount,
        subtotalAfterDiscount,
        subtotalAfterSpecialDiscount,
        gstAmount,
        vatAmount,
        totalTax: gstAmount + vatAmount,
        total: subtotalAfterSpecialDiscount + gstAmount + vatAmount
    };
};
